export const STATUSES = {
    draft: {
        label: 'Draft',
        short: 'Draft',
        color: 'draft',
        bg: '#dfe1e6',
        text: '#5e6c84',
        border: '#c1c7d0',
    },
    field_review: {
        label: 'Field Review',
        short: 'Field Rev.',
        color: 'field_review',
        bg: '#fff0b3',
        text: '#172b4d',
        border: '#ffab00',
    },
    ready_for_invoice: {
        label: 'Ready for Invoice',
        short: 'Ready',
        color: 'ready_for_invoice',
        bg: '#deebff',
        text: '#0052cc',
        border: '#4c9aff',
    },
    estimated: {
        label: 'Estimated — awaiting customer',
        short: 'Estimated',
        color: 'estimated',
        bg: '#fff4e5',
        text: '#974f0c',
        border: '#ff991f',
    },
    invoiced: {
        label: 'Invoiced',
        short: 'Invoiced',
        color: 'invoiced',
        bg: '#e3fcef',
        text: '#006644',
        border: '#57d9a3',
    },
    // Set by the Ayrical DB trigger when an invoiced ticket's QBO invoice is
    // paid. Billed, locked and terminal like `invoiced`; solid green matches the
    // `--status-paid-*` tokens in frontend/src/styles/app.css.
    paid: {
        label: 'Paid',
        short: 'Paid',
        color: 'paid',
        bg: '#006644',
        text: '#ffffff',
        border: '#006644',
    },
    archived: {
        label: 'Archived',
        short: 'Archived',
        color: 'archived',
        bg: '#f4f5f7',
        text: '#97a0af',
        border: '#dfe1e6',
    },
};
/** Ordered status workflow */
export const STATUS_ORDER = [
    'draft',
    'field_review',
    'ready_for_invoice',
    'estimated',
    'invoiced',
    'paid',
    'archived',
];
/** True when the ticket has been billed: `invoiced`, or `paid` (its QBO invoice was paid). */
export function isBilledStatus(status) {
    return status === 'invoiced' || status === 'paid';
}
export function getStatusInfo(status) {
    return (STATUSES[status] ?? {
        label: status,
        short: status,
        color: 'draft',
        bg: '#dfe1e6',
        text: '#5e6c84',
        border: '#c1c7d0',
    });
}
/**
 * Effective full label for a ticket's status chip. Identical to
 * `getStatusInfo(status).label` for every status EXCEPT an 'estimated' ticket
 * whose estimate has already been emailed (`estimate_sent_at` set), which reads
 * "Estimate sent" instead of "Estimated — awaiting customer".
 */
export function getEffectiveStatusLabel(ticket) {
    if (ticket.status === 'estimated' && ticket.estimate_sent_at) {
        return 'Estimate sent';
    }
    return getStatusInfo((ticket.status ?? '')).label;
}
//# sourceMappingURL=statuses.js.map